import { HsLight } from './light.class';

export class HsAmbientLight extends HsLight {}
